export interface SplitPage {
    pageNumber: number;
    status: string;
}

export interface SplitDocument {
    idDocument: number;
    /** Zero-based page indexes of the source PDF. */
    pages: number[];
}

/**
 * Groups the kept pages into documents. A "splitted" page ends its document, deleted pages
 * are dropped, and the pages after the last cut form a final document even when the last
 * page of the PDF was deleted.
 */
export const buildSplitDocuments = (pages: Array<SplitPage>): Array<SplitDocument> => {
    const documents: Array<SplitDocument> = [];
    let current: number[] = [];

    pages.forEach(page => {
        if (page.status === 'deleted') return;
        current.push(page.pageNumber - 1);
        if (page.status === 'splitted') {
            documents.push({ idDocument: documents.length, pages: current });
            current = [];
        }
    });

    if (current.length) {
        documents.push({ idDocument: documents.length, pages: current });
    }
    return documents;
};

/** Name of the nth document, numbered in page order. */
export const splitDocumentName = (position: number, fileName: string) => `${position}-${fileName}`;
